export default "__VITE_ASSET__BCG1UwOg__"